function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Chip from '@material-ui/core/Chip';
import clsx from 'clsx';
import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import { getLabelSliced } from "../../utils/selectHelper";
export function MultiValue(_ref) {
  var _clsx;

  var children = _ref.children,
      selectProps = _ref.selectProps,
      removeProps = _ref.removeProps,
      isFocused = _ref.isFocused;
  var label = getLabelSliced(children);
  return /*#__PURE__*/React.createElement(Chip, {
    size: "small",
    tabIndex: -1,
    label: label,
    className: clsx((_clsx = {}, _defineProperty(_clsx, selectProps.childrenClasses.chip, selectProps.variant === 'web'), _defineProperty(_clsx, selectProps.childrenClasses.chipFocused, isFocused), _clsx)),
    onDelete: removeProps ? removeProps.onClick : undefined,
    deleteIcon: removeProps ? /*#__PURE__*/React.createElement(CancelIcon, removeProps) : undefined
  });
}